import React from "react";
import "../css/TripCard.css";

const TripCard = ({ title, startDate, endDate, description, photo, photoSource, footerName, isClickable }) => {
  const maxDescriptionLength = 300;

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const areDatesEqual = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const displayDate =
    startDate && endDate
      ? areDatesEqual(startDate, endDate)
        ? formatDate(startDate)
        : `${formatDate(startDate)} - ${formatDate(endDate)}`
      : "";

  const trimmedDescription =
    description && description.length > maxDescriptionLength
      ? description.slice(0, maxDescriptionLength) + "..."
      : description;

  return (
    <div className="trip-card">
      <div className="trip-card-header">
        <h2 className="trip-card-title">{title}</h2>
        <p className="trip-card-dates">{displayDate}</p>
      </div>

      <div className="trip-card-image">
        <img src={photo} alt={title} />
        <p className="trip-card-photo-source">Zdjęcie: {photoSource}</p>
      </div>

      <div className="trip-card-description">
        <p>{trimmedDescription}</p>
      </div>

      {footerName && (
        <div className="trip-card-footer">
          {isClickable ? (
            <a href="#" className="trip-card-link"> {footerName} </a>
          ) : (
            <span className="trip-card-link disabled" aria-disabled="true">{footerName}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default TripCard;
